import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Icon from './Icon';
import Title from './Title';
import { palette, flexRow, flexCenter } from '../../constants/styles';
import Button from './Button';
import Text from './Text';
const StyledPlusMinusContainer = styled.div`
  ${flexRow}
  ${flexCenter}
`;

const RowButtons = styled.div`
  ${flexRow}
  justify-content: space-around;
  align-items: center;
  width: 300px;
  height: fit-content;
  padding: 10px;
`;

const TransparentCheck = styled.div`
  width: 80px;
  height: 20px;
`;

const Check = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 25px;
  margin: 0 5px 5px 0;
  padding: 0 10px;

  margin-right: 0.3rem;
  width: 80px;
  padding: 0px 10px;
  min-height: 40px;
  height: fit-content;
  margin-bottom: 0.3rem;
  border: none;
  border-radius: 8px;
  background-color: ${palette.secondaryColor};
  box-shadow: 2px 2px 15px -3px rgba(0, 0, 0, 0.25);
  cursor: pointer;

  :hover {
    background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));
  }
`;

const PlusMinus = ({
  titleLevel = 2,
  minusFunction,
  plusFunction,
  changingNumber,
  changingNumberColor,
  retirementOptions,
  min,
  max,
  prepend,
  postpend,
}) => {
  return (
    <StyledPlusMinusContainer>
      <RowButtons>
        {changingNumber - 1 >= min ? (
          <Check
            onClick={() => {
              minusFunction();
            }}
          >
            <Icon style={{ margin: '5px' }} icon="arrowBack" color="white" size={20} />
            <Text type="buttonText" color="white" medium>
              {changingNumber - 1}
            </Text>
          </Check>
        ) : (
          <TransparentCheck />
        )}

        <Title
          style={{ margin: '10px', width: '100px', textAlign: 'center' }}
          level={2}
          color={changingNumberColor}
        >
          {changingNumber}{' '}
          <span style={{ color: palette.terciaryColor, fontSize: '16px' }}>años</span>
        </Title>
        {changingNumber + 1 <= max ? (
          <Check
            onClick={() => {
              plusFunction();
            }}
          >
            <Text type="buttonText" color="white" medium>
              {changingNumber + 1}
            </Text>
            <Icon style={{ margin: '5px' }} icon="arrowFront" color="white" size={20} />
          </Check>
        ) : (
          <TransparentCheck />
        )}
      </RowButtons>
    </StyledPlusMinusContainer>
  );
};

PlusMinus.propTypes = {
  changingNumber: PropTypes.string,
  minusFunction: PropTypes.func,
  plusFunction: PropTypes.func,
};

PlusMinus.defaultProps = {
  changingNumber: '',
  minusFunction: () => {},
  plusFunction: () => {},
};

export default PlusMinus;
